<template>
  <div class="bg-secondary-3 p-2">
    <div class="bg-white rounded p-3">
      <div class="mt-2">
        <em class="fas fa-clock text-orange mr-1" />
        <span class="color-gray-7 font-16 font-weight-bold">
          Historial de Estatus
        </span>
      </div>

      <custom-result-not-found
        v-if="!records.length"
        class="mt-4 row mx-auto pt-3"
        text="No hay Información Disponible."
      />

      <time-line v-else class="mt-4">
        <div v-for="(historyItem, index) in records" :key="index">
          <time-line-item class="custom-time-line rounded">
            <template #date>
              <div class="date-container">
                <div class="color-black font-16 font-weight-bold fulldate">
                  {{ historyItem.actionDate | date }}
                </div>
                <div class="color-black font-12 font-weight-bold hour">
                  {{ historyItem.actionDate | hour }}
                </div>
              </div>
            </template>

            <div class="row mx-auto mx-1">
              <div class="col col-md-3">
                <custom-balloon
                  class="d-lc-inline"
                  :text="historyItem.statusName"
                  :background-color="getColor(historyItem.statusId)"
                />
              </div>
              <div class="col col-md-9">
                <div class="color-gray-6 font-14 font-weight-normal">
                  Cambiado por:
                </div>
                <div class="color-black font-16 font-weight-normal label-value">
                  {{ historyItem.actionByUser | empty }}
                </div>
              </div>
              
              <div class="col col-md-3"></div>
              <div
                v-if="historyItem.statusId == oreStatuses.denied && historyItem.deniedComment"
                class="col col-md-9"
              >
                <div class="bg-white rounded p-3 mt-3">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Comentario:
                  </div>
                  <div>
                    {{ historyItem.deniedComment | empty }}
                  </div>
                </div>
              </div>
            </div>
          </time-line-item>
        </div>
      </time-line>

      <div class="d-flex justify-content-end mt-4">
        <action-button
          variant="danger mr-2"
          i="fas fa-times-circle"
          text="Cerrar"
          @click="$emit('hide')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { CustomResult } from '@/components/common/FilterCustomManager';
import { Colors } from '../../common';
import oreStatusEnum from '@/utils/constants/student/childCountOreStatusEnum';
import { ActionButton } from '@/components/common';
import { TimeLine, TimeLineItem } from "@quisit/mipe-timeline";
import CustomBalloon from '@/components/common/CustomBalloon';
import CustomResultNotFound from "custom-result-not-found";

export default {
  name: 'OreStatusTimeLine',
  components: {
    CustomResult,
    ActionButton,
    TimeLine,
    TimeLineItem,
    CustomBalloon,
    CustomResultNotFound,
  },
  props: {
    records: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    oreStatuses() {
      return oreStatusEnum;
    },
    getColor() {
      return (status) => {
        switch (status) {
          case this.oreStatuses.notSubmitted:
            return Colors.GRAY;
          case this.oreStatuses.approved:
            return Colors.GREEN;
          case this.oreStatuses.submitted:
            return Colors.YELLOW;
          case this.oreStatuses.denied:
            return Colors.BROWN;
          default:
            return '';
        }
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables/_colors.scss";


:deep(.w-date-fixed) {
  width: 120px !important;
}
</style>
